import { autobind } from 'core-decorators';

class TickerServiceClass {
    all = [];

    constructor() {
        this.raf = null;

        this.addListeners();
    }

    addListeners() {
        this.raf = requestAnimationFrame(this.onTick);
    }

    removeListeners() {
        if (this.raf) {
            cancelAnimationFrame(this.raf);
            this.raf = null;
        }
    }

    add(handler) {
        this.all.push(handler);
    }

    remove(handler) {
        this.all.splice(this.all.indexOf(handler) >>> 0, 1); // eslint-disable-line no-bitwise
    }

    @autobind
    onTick(delta) {
        this.all.map((handler) => handler(delta / 1000));
        this.raf = requestAnimationFrame(this.onTick);
    }
}

const TickerService = new TickerServiceClass();

export default TickerService;
